import type { Roles } from "@/shared/@types/Roles";

export const isCustomerRoleIncluded = <K>(
  accessor: K,
  mappings: Map<K, Array<Roles>>,
  customerRoles: Array<Roles>,
) => {
  return !!mappings.get(accessor)?.some((role) => customerRoles.includes(role));
};
